import React from 'react'
import CustomDialog from '../../../components/CustomDialog';
import { ImCross,ImBin  } from "react-icons/im";

const DetailsLog = (props) => {
     const { open, setOpen, isMobile, messages, handleClear } = props;

     const handleClose = () => setOpen(false);

    return (
        <CustomDialog open={open} width={500} isMobile={isMobile} padding={2}>
            <h3 className='text-center font-semibold mb-1 dark:text-customWhite'>Recalculation Details Log</h3>
            <div className='p-3 bg-gray-200 shadow-sm rounded-md flex flex-col justify-center max-h-[300px] overflow-y-auto'>
                {
                    messages.length > 0 ? messages.map((msg, i) => {
                        return (
                            <p key={i} style={{ fontSize:12,fontWeight:'semi-bold',color: msg.startsWith("ERROR") ? "red" : "black" }}>
                                {msg}
                            </p>
                        )
                    }) : 
                    <span className='text-sm text-black font-medium text-center'>No log found.</span>
                }
            </div>
            <div className='flex justify-center items-center gap-2 mt-2'>
                <button
                    className='flex items-center px-3 py-1 border rounded bg-customFontRed/10 text-customFontRed border-customFontRed'
                    onClick={() => handleClear()}
                ><ImBin className='mr-1' />Clear
                </button>
                <button
                    className='flex items-center px-3 py-1 border rounded bg-customTitleColor/20 text-customHeader dark:text-customTitleColor border-customTitleColor'
                    onClick={() => handleClose()}
                ><ImCross className='mr-1' />Close
                </button>
            </div>
        </CustomDialog>
    )
}

export default DetailsLog;